export default {
  meta: {
    title: '标准模型推荐',
    url: '/recommend/map', // 埋点用，记录所属模块
    // eventId: 'f2f659ec-bd79-4ed4-ad36-491a42150f62'
  },
};
